module.exports = flarum.core.compat['common/extend'];